import { apiFetch } from './api';

const API_URL = process.env.REACT_APP_API_URL || '/api';

/**
 * Envoi multipart d'un fichier avec ses champs. Hors apiFetch : celui-ci
 * force le Content-Type JSON, alors que le navigateur doit poser lui-même
 * la frontière du multipart. Le cookie de session suit (credentials).
 */
async function envoyerFichier(chemin, fichier, champs = {}) {
  const corps = new FormData();
  for (const [cle, valeur] of Object.entries(champs)) {
    if (valeur !== undefined && valeur !== null && valeur !== '') corps.append(cle, valeur);
  }
  corps.append('fichier', fichier);

  const res = await fetch(`${API_URL}${chemin}`, {
    method: 'POST',
    credentials: 'include',
    body: corps,
  });
  const json = await res.json().catch(() => ({}));
  if (!res.ok) {
    const err = new Error(json?.message || `Dépôt impossible (${res.status})`);
    err.status = res.status;
    throw err;
  }
  return json;
}

/* ---------- Page de signature du devis (client, par jeton) ---------- */

/** Pièces attendues et déposées pour le devis du lien reçu par email. */
export function getDocumentsParToken(token) {
  return apiFetch(`/devis/reponse/${token}/documents`);
}

/** Le client dépose une pièce : attendue (formationDocumentId) ou libre (libelle). */
export function deposerDocumentParToken(token, fichier, { formationDocumentId, libelle } = {}) {
  return envoyerFichier(`/devis/reponse/${token}/documents`, fichier, {
    formationDocumentId,
    libelle,
  });
}

/* ---------- Dossier client (back-office) ---------- */

export function getDocumentsContact(contactId) {
  return apiFetch(`/contacts/${contactId}/documents`);
}

export function deposerDocumentContact(
  contactId,
  fichier,
  { formationDocumentId, libelle, devisId, categorie } = {}
) {
  return envoyerFichier(`/contacts/${contactId}/documents`, fichier, {
    formationDocumentId,
    libelle,
    devisId,
    categorie,
  });
}

/** Les documents générés pour ce client — toutes ses demandes confondues. */
export function getDocumentsGeneres(clientId) {
  return apiFetch(`/documents-client/generes/${clientId}`);
}

export function urlFichierGenere(categorie, id, { apercu = false } = {}) {
  return `${API_URL}/documents-client/genere/${categorie}/${id}/fichier${apercu ? '?apercu=1' : ''}`;
}

export function supprimerDocument(id) {
  return apiFetch(`/documents-client/${id}`, { method: 'DELETE' });
}

/** Renomme une pièce : le libellé affiché et le nom du fichier téléchargé. */
export function renommerDocument(id, libelle) {
  return apiFetch(`/documents-client/${id}`, {
    method: 'PUT',
    body: JSON.stringify({ libelle }),
  });
}

/** URL du fichier : `apercu` l'ouvre dans l'onglet, sinon téléchargement. */
export function urlFichierDocument(id, { apercu = false } = {}) {
  return `${API_URL}/documents-client/${id}/fichier${apercu ? '?apercu=1' : ''}`;
}

/** Taille lisible : « 1,2 Mo ». */
export function formatTaille(octets) {
  const n = Number(octets);
  if (!Number.isFinite(n)) return '';
  if (n < 1024) return `${n} o`;
  if (n < 1024 * 1024) return `${(n / 1024).toLocaleString('fr-FR', { maximumFractionDigits: 0 })} Ko`;
  return `${(n / (1024 * 1024)).toLocaleString('fr-FR', { maximumFractionDigits: 1 })} Mo`;
}
